import { runFunction } from "../../http";

export const addFollows = async (userIds: string[]): Promise<void> => {
  console.debug("[Service] addFollows", userIds);
  await runFunction("addFollows", { userIds: userIds }, { requireUser: true });
};
